export enum PostReportType {
  SPAM = 'SPAM',
  ILLEGAL = 'ILLEGAL',
  INAPPROPRIATE = 'INAPPROPRIATE'
}
